import React, { useContext } from "react";
import { LegacyCard as Card, InlineStack, Link, Text, DataTable, InlineCode } from "@shopify/polaris";

import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { customerProp } from "app/orders/modules/provider/features/view/propsType";
import { baseHelper } from "lib/helpers";

const Pickup = (props) => {
  const { lineData } = props;
  const { cms } = useContext(PrivateContext);
  let statusHeading = "";

  const getFulfillmentStack = (item) => {
    const { address, city, country, pinCode } = item.consignmentPickAddress || {};
    const { status: hopscotchStatus = "" } = (item && item.hopscotch) || {};
    const { shipsyDetails, consignmentUrl } = item;
    statusHeading = hopscotchStatus ? "Status" : "";

    return [
      <>
        <Link url="">{item.name}</Link>
        <Text variant="bodySm" as="p">
          <Text as="span" tone="subdued">{`${cms("label.vendor")}: ${item.vendor}`}</Text>
        </Text>
        <br />
        {shipsyDetails && shipsyDetails.type ? (
          <Text as="span">
            Last Event:
            <InlineCode>{baseHelper.convertToPascalCase(shipsyDetails.type)}</InlineCode>
          </Text>
        ) : (
          ""
        )}
        {shipsyDetails && shipsyDetails.event_time ? (
          <Text as="span">
            Event Time:
            <Text as="span">{baseHelper.formatDate(new Date(shipsyDetails.event_time))}</Text>
          </Text>
        ) : (
          ""
        )}
        {consignmentUrl ? (
          <Link target="_blank" url={consignmentUrl}>
            Airway Bill
          </Link>
        ) : (
          ""
        )}
      </>,

      <>
        {address ? (city && `${address},`) || address : ""}
        <br />
        {city ? (country && `${city},`) || city : ""}
        <br />
        {country ? (pinCode && `${country},`) || country : ""}
        {pinCode ? [<br />, pinCode || ""] : ""}
      </>,

      hopscotchStatus ? <Text as="span">{baseHelper.ucFirst(hopscotchStatus).replace(/-/g, " ") || ""}</Text> : "",
    ];
  };

  const fulfillments = lineData
    .filter((item) => item.isVendorFulfilled && item.isConsignmentPick && item.fulfillmentStatus !== constant.FULFILLED)
    .map((selectedItem) => getFulfillmentStack(selectedItem));

  return (
    <div className="add-ellipsis">
      <Card.Section subdued>
        <DataTable
          columnContentTypes={["text", "text", statusHeading ? "numeric" : ""]}
          headings={[cms("label.product"), cms("label.pickupLocation"), statusHeading]}
          rows={fulfillments}
        />
      </Card.Section>
      <Card>
        <Card.Section>
          <InlineStack blockAlign="center">
            <Text as="span" fontWeight="semibold">
              {cms("label.totalFulfillments")}
            </Text>
            <Text as="span" fontWeight="semibold">
              {`${fulfillments.length} ${cms("label.of")} ${lineData.length}`}
            </Text>
          </InlineStack>
        </Card.Section>
      </Card>
    </div>
  );
};

Pickup.propTypes = customerProp.type;
export default Pickup;
